
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  resizeSelects: function(selects) {
    selects.forEach(function(select) {
      var arrowWidth = 55;

      var test = document.createElement('span');
      test.innerHTML = select.selectedOptions[0].label;

      //document.querySelector('.site-footer').appendChild(test);

      var width = test.offsetWidth + arrowWidth;
      test.remove();

      select.style.width = width + 'px';
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.tables.forEach(function(table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.iframes.forEach(function(iframe) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);

      iframe.src = iframe.src;
    });
  }
};

window.slate = window.slate || {};

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function(element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function(options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function(element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function() {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function() {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function(evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function(evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function(options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function(link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    var statusMessages = document.querySelectorAll(selectors.statusMessage);

    statusMessages.forEach(function(statusMessage) {
      statusMessage.setAttribute('tabindex', -1);
      statusMessage.focus();

      statusMessage.addEventListener(
        'blur',
        function(evt) {
          evt.target.removeAttribute('tabindex');
        },
        { once: true }
      );
    });
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.TouchEvents = function TouchEvents(element, options) {
  this.axis;
  this.checkEvents = [];
  this.eventHandlers = {};
  this.eventModel = {};
  this.events = [
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
    ['mousedown', 'mousemove', 'mouseup']
  ];
  this.eventType;
  this.difference = {};
  this.direction;
  this.start = {};

  this.element = element;
  this.options = Object.assign(
    {},
    {
      dragThreshold: 10,
      start: function() {}, // eslint-disable-line
      move: function() {}, // eslint-disable-line
      end: function() {} // eslint-disable-line
    },
    options
  );

  this.checkEvents = this._getCheckEvents();
  this.eventModel = this._getEventModel();

  this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
  destroy: function() {
    this.element.removeEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    this.element.removeEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    if (!this.eventModel) {
      this.element.removeEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    this.element.removeEventListener('click', this.eventHandlers.preventClick);
  },

  _setupEventHandlers: function() {
    this.eventHandlers.preventDefault = this._preventDefault.bind(this);
    this.eventHandlers.preventClick = this._preventClick.bind(this);
    this.eventHandlers.touchStart = this._touchStart.bind(this);
    this.eventHandlers.touchMove = this._touchMove.bind(this);
    this.eventHandlers.touchEnd = this._touchEnd.bind(this);

    // Prevent element from dragging when using mouse
    this.element.addEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    // Bind the touchstart/pointerdown event
    this.element.addEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    // Bind mousedown if necessary
    if (!this.eventModel) {
      this.element.addEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    // No clicking during touch
    this.element.addEventListener('click', this.eventHandlers.preventClick);
  },

  _touchStart: function(event) {
    this.eventType = this.eventModel;

    if (event.type === 'mousedown' && !this.eventModel) {
      this.eventType = 2;
    }

    if (this.checkEvents[this.eventType](event)) return;
    if (this.eventType) this._preventDefault(event);

    document.addEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.addEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.addEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    this.start = {
      xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
      yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
      time: new Date().getTime()
    };

    // Ensure we empty out the this.difference object
    Object.keys(this.difference).forEach(
      function(key) {
        delete this.difference[key];
      }.bind(this)
    );

    this.options.start(event);
  },

  _touchMove: function(event) {
    this.difference = this._getDifference(event);

    // Prevent document from scrolling during swipe gesture
    document['on' + this.events[this.eventType][1]] = function(event) {
      this._preventDefault(event);
    }.bind(this);

    // Get the direction user is dragging
    if (!this.axis) {
      if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
        this.axis = 'xPosition';
      } else if (
        this.options.dragThreshold < Math.abs(this.difference.yPosition)
      ) {
        this.axis = 'yPosition';
      } else {
        this.axis = false;
      }
    } else if (this.axis === 'xPosition') {
      this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
    } else if (this.axis === 'yPosition') {
      this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
    }

    this.options.move(event, this.direction, this.difference);
  },

  _touchEnd: function(event) {
    document.removeEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.removeEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.removeEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    // Re-enable document scrolling
    document['on' + this.events[this.eventType][1]] = function() {
      return true;
    };

    this.options.end(event, this.direction, this.difference);
    this.axis = false;
  },

  _getDifference: function(event) {
    return {
      xPosition:
      (this.eventType ? event.clientX : event.touches[0].clientX) -
      this.start.xPosition,
      yPosition:
      (this.eventType ? event.clientY : event.touches[0].clientY) -
      this.start.yPosition,
      time: new Date().getTime() - this.start.time
    };
  },

  _getCheckEvents: function() {
    return [
      // Touch events
      function(event) {
        // Skip the event if it's a multi-touch or pinch move
        return (
          (event.touches && event.touches.length > 1) ||
          (event.scale && event.scale !== 1)
        );
      },
      // Pointer events
      function(event) {
        // Skip it, if:
        // 1. The event is not primary (other pointers during multi-touch),
        // 2. Left mouse button is not pressed,
        // 3. Event is not a touch event
        return (
          !event.isPrimary ||
          (event.buttons && event.buttons !== 1) ||
          (event.pointerType !== 'touch' && event.pointerType !== 'pen')
        );
      },
      // Mouse events
      function(event) {
        // Skip the event if left mouse button is not pressed
        return event.buttons && event.buttons !== 1;
      }
    ];
  },

  _getEventModel: function() {
    return window.navigator.pointerEnabled ? 1 : 0;
  },

  _preventDefault: function(event) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
  },

  _preventClick: function(event) {
    if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
      this._preventDefault(event);
    }
  }
});

theme.Helpers = (function() {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this,
          args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function(event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];

    var duration = 0;

    properties.forEach(function(property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function(resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function() {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'plyr/v2.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function OpenClubPoup(OpenClubPoup){
  if($(".sign_up_karma_club_popup").length > 0){
    setTimeout(function(){
    let ClubKarmaPopup = getCookie("ClubKarmaPopup");
    //console.log("dfs"+ClubKarmaPopup)
    if (ClubKarmaPopup === "") {
      $('html').addClass('active_popup');
    }
    },30000)
  }
}
function CloseClubPoup(CloseClubPoup){
  if($(".sign_up_karma_club_popup").length > 0){
    $('html').removeClass('active_popup');
    setCookie("ClubKarmaPopup", "true", "30");
  }
}
function closeMenu(closeMenu){
  $('.deskMenu').removeClass("open-Menu"); 
}
function openMenu(openMenu){
  getMegaMenu()
  $('.deskMenu').addClass("open-Menu"); 
}
function accountOpen(accountOpen){
  $(accountOpen).parents('li.dropdown-grid').toggleClass("openBox") 
}
function getMegaMenu(){
  if (!$('.deskMenu.page-width').hasClass("dataAdded")) {
    $(".deskMenu.page-width").addClass("dataAdded");
    $.ajax({
      url:  '/?view=alternate',
      type: 'GET',
      success: function (data) {
        $('.deskMenu.page-width').html($(data).filter('main#MainContent').html());

        $('.wsmenu-click02').click(function() {
          if($(this).hasClass('wsmenu-rotate')){
          }else{
            $('.wsmenu-click02').removeClass('wsmenu-rotate')
            $('ul.wsmenu-sub-list li.link-list ul').slideUp('slow');
          }
          $(this).toggleClass('wsmenu-rotate');
          $(this).parent('li.link-list').find('ul').slideToggle('slow');
        });
        $('nav#AccessibleNav span.arrow').click(function(){
          if($(this).hasClass('rotate')){
          }else{
            $('nav#AccessibleNav .megamenu ').slideUp("slow");
            $('nav#AccessibleNav span.arrow').removeClass("rotate");
          }
          $(this).parents('li').children('.megamenu').slideToggle("slow");
          $(this).toggleClass("rotate");
        })
      }
    })
  }
}
function getFooter(){
  if (!$('#shopify-section-footer').hasClass("dataAdded")) {
    $("#shopify-section-footer").addClass("dataAdded");
    $.ajax({
      url:  '/?view=alternate',
      type: 'GET',
      success: function (data) {
        $('#shopify-section-footer').html($(data).filter('#shopify-section-footer').html());

      }
    })
  }
}

function cartdrawer(){
  $.ajax({
    url:  '/cart',
    type: 'GET',
    success: function (data) {
      $('.CartDrawerBox').html("");
      var content = $(data).find('div#shopify-section-cart-template').html();
      // console.log(content);
      $(".CartDrawerBox").html(content);
      $("body").addClass("OpenDrawer"); 
    }
  })
}
function closeDrawer(){
  $("body").removeClass("OpenDrawer"); 
}
function plusItem(plusItem){
  var productHandle = $(plusItem).attr('dataHandle');
  var inputEl = $(plusItem).parents('.qtybbox').find('input.cart__qty-input');
  var variantId = $(plusItem).attr('dataVariantId')
  var qty = inputEl.val();
  var line =  $(plusItem).attr('dataline')
  jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
    for (var i=0,length=product.variants.length; i<length; i++) {
      if(product.variants[i].id == variantId){
        var variant = product.variants[i];
        if (qty >= variant.inventory_quantity && variant.inventory_management == "shopify" && variant.inventory_policy != "continue") {
          $(plusItem).parents('.cart__quantity-td').find(".cart__qty-error-message-wrapper").show().delay(3000).fadeOut();
        }
        else{
          qty++;
          inputEl.val(qty);
          var data = 'quantity='+qty+'&line='+line;
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function(cart){
              if (!$('body').hasClass("template-cart")) {
                cartdrawer()
              }else{
                window.location.href='/cart'; 
              }

            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }   
          });     
        }
        break;
      }       
    }

  });  
}
function minusItem(minusItem){
  var productHandle = $(minusItem).attr('dataHandle');
  var inputEl = $(minusItem).parents('.qtybbox').find('input.cart__qty-input');
  var variantId = $(minusItem).attr('dataVariantId')
  var qty = inputEl.val();
  var line =  $(minusItem).attr('dataline');
  if ($(minusItem).parent().hasClass("minus_btn"))
    qty++;
  else
    qty--;
  if (qty < 1)
    qty = 1;
  inputEl.val(qty);
  var data = 'quantity='+qty+'&line='+line;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function(cart){
      if (!$('body').hasClass("template-cart")) {
        cartdrawer()
      }else{
        window.location.href='/cart'; 
      }

    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }   
  });   
}
function removeItem(removeItem){
  var line =  $(removeItem).attr('dataline');
  var qty = 0;
  var data = 'quantity='+qty+'&line='+line;

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function(cart){
      if (!$('body').hasClass("template-cart")) {
        cartdrawer()
      }else{
        window.location.href='/cart'; 
      }

    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }   
  });   
}
var cartCount = parseInt($('.MyHeader .Hsearch a.dropdown-toggle span.count').html());

function addItem(form_id) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + form_id)
    .serialize(),
    success: addToCartOk,
    error: addToCartFail
  });
}
function showCart() {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + form_id)
    .serialize(),
    success: addToCartOk,
    error: addToCartFail
  });
}
function addToCartOk(product) {
  cartCount++;
  $('.modal')
  .html('<span class="close" id="close" onclick="closeModal()">✕</span><p>' + product.title + ' was added to the cart!</p>');
  $('.MyHeader .Hsearch a.dropdown-toggle span.count').html(cartCount);
  openModal();
}
function addToCartFail(obj, status) {
  $('.modal')
  .html('<span class="close" id="close" onclick="closeModal()">✕</span><p>The product you are trying to add is out of stock.</p>');
  openModal();
}
//open modal and overlay
function openModal() {
  $('.modal')
  .removeClass('hidden')
  .addClass('open');
  $('.modal--overlay')
  .removeClass('hidden')
  .addClass('open');
  $('body')
  .css('overflow', 'hidden');
}
//close modal and overlay
function closeModal() {
  $('.modal--overlay').addClass('hidden')
  .removeClass('open');
  $('.modal.open')
  .addClass('hidden')
  .removeClass('open');
  $('body')
  .css('overflow', 'auto');
}
function ViewOptions(viewOpt){
  $('.ProductAddAction').removeClass("open-options")
  $(viewOpt).parents('.ProductAddAction').addClass("open-options");

}
function closeOpt(closeOpt){
  $(closeOpt).parents('.ProductAddAction').removeClass("open-options");

}
function optonChange(optonChange){
  var selectedOptions = '';
  var product_handle = $(optonChange).parents('.ProductAddAction').attr('data-handle');
  $(optonChange).parents('.ProductAddAction').find('.selector-wrapper select').each(function(){
    if (selectedOptions == '') {

      selectedOptions = $(this).val();

    } else {

      selectedOptions = selectedOptions + ' / ' + $(this).val();

    }
  })

  var typeId = selectedOptions;
  $(optonChange).parents('.ProductAddAction').find('.product-form__variants option').removeAttr("selected");

  $(optonChange).parents('.ProductAddAction').find('.product-form__variants option[data-title="'+selectedOptions+'"]').attr("selected","selected");

  var checkAvl = $(optonChange).parents('.ProductAddAction').find('.product-form__variants option[data-title="'+selectedOptions+'"]').attr('dataAvl');
  if(checkAvl == 'true'){
    $(optonChange).parents('.ProductAddAction').find('.vaopiton .btn').removeAttr('disabled').html('Add to Cart');

  }else{
    $(optonChange).parents('.ProductAddAction').find('.vaopiton .btn').attr('disabled', 'disabled').html('Sold Out');

  }

}
function chkout(e){$("input.cart__submit.btn.btn--small-wide").trigger("click")}
$(document).ready(function() {
  $('.MyHeader .Hsearch a.dropdown-toggle span.count')
  .html(cartCount);
  $('.modal--overlay')
  .on('click', function() {
    closeModal();
  });
}); 
$(document).on("click", function(event){
  var $trigger = $("li.dropdown-grid.openBox");
  if($trigger !== event.target && !$trigger.has(event.target).length){
    $("li.dropdown-grid").removeClass("openBox");
  }            
});
$(window).on("scroll touchmove", function() {
  var scroll = $(window).scrollTop();
  var headerTop = $('.header-top').outerHeight();
  var header= $(".MyHeader").outerHeight();
  var stickpoint = header+headerTop;

  var wWidth = $(window).width();
  //console.log(wWidth)
  if (wWidth > 798){
    var BodyPadding = $("nav#AccessibleNav").outerHeight();  
    if(scroll >  stickpoint){
      $(".site-header").addClass('sticky');
      $(".main-content").css("marginTop", BodyPadding + "px");
    }else{
      $(".site-header").removeClass('sticky');
      $(".main-content").css("marginTop","0"); 
    }
  }else{
    var BodyPadding = header+$('.MobileSearch.medium-up--hide').outerHeight();
    if(scroll >  headerTop){
      $(".site-header").addClass('Msticky');
      $(".main-content").css("marginTop", BodyPadding + "px"); 
    }else{
      $(".site-header").removeClass('Msticky');
      $(".main-content").css("marginTop","0"); 
    }
  }
  if(scroll >  10){
    getFooter();
  }
});
document.addEventListener('DOMContentLoaded', function() {
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';
  slate.rte.wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });
  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"],' +
      '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
      '.custom__item-inner--html iframe[src*="player.vimeo"]';
  if(screen.width <=767){
    slate.rte.wrapIframe({
      iframes: document.querySelectorAll(iframeSelectors),
      iframeWrapperClass: 'video-wrapper'
    });
  }
  document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(evt) {
      evt.preventDefault();
    });
  });
  theme.FormStatus.init();
  var selectors = {
    image: '[data-image]',
    lazyloaded: '.lazyloaded'
  };
  document.addEventListener(
    'touchstart',
    function() {
      theme.Helpers.setTouch();
    },
    { once: true }
  );
  if (document.fonts) {
    document.fonts.ready.then(function() {
    });
  }
  //$('#datepicker').datepicker({ dateFormat: 'yy-mm-dd',changeMonth: true,yearRange: "-100:+0",changeYear: true });
  if($('#datepicker').length>0){
    const picker = datepicker('#datepicker',{
      formatter: (input, date, instance) => {
        const value = date.toLocaleDateString("en-US", { year: 'numeric' })+"-"+ date.toLocaleDateString("en-US", { month: 'numeric' })+ "-"+date.toLocaleDateString("en-US", { day: 'numeric' });  // 16-Nov-2019
        input.value = value;
        input.classList.add("valid");// => '1/1/2099'
      }
    });

  }
  let formInput = document.querySelectorAll("form#create_customer input");
  for (var i = 0; i < formInput.length; i++) {
    formInput[i].onkeyup = function() {
      let input=this;
      let inputType=input.getAttribute('dataType');
      if(inputType == 'email'){
        let input=this;
        let re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let is_email=re.test(input.value);
        if(is_email){
          input.classList.remove("invalid");
          input.classList.add("valid");
          input.classList.remove("missing");
        }
        else{
          input.classList.remove("valid");
          input.classList.add("invalid");
        }
      }
      if(inputType == "text"){
        let message=this.value;

        if(message){
          input.classList.remove("invalid");
          input.classList.add("valid");
          input.classList.remove("missing");
        }
        else{
          input.classList.remove("valid");
          input.classList.add("invalid");
        }
      }
      if(inputType == "number"){
        let message=this.value;

        if (isNaN(message)) 
        {
          input.classList.remove("valid");
          input.classList.add("invalid");
        }else{

          input.classList.remove("invalid");
          input.classList.add("valid");
          input.classList.remove("missing");
        }
      }
      if(inputType == "password"){
        let message=this.value;
        let password = document.querySelector('#confirm_password').value;

        if(message.length > 4){
          input.classList.remove("missing");
          if (password.length > 0){
            if(password == message){ 
              input.classList.remove("invalid");
              input.classList.add("valid");
              document.querySelector('#confirm_password').classList.remove("invalid");
              document.querySelector('#confirm_password').classList.add("valid");
              input.classList.remove("error");
            }else{
              input.classList.remove("valid");
              input.classList.add("invalid");
              input.classList.add("error"); 
            }
          }else{
            input.classList.remove("valid");
            input.classList.add("invalid");
            input.classList.add("error");  
          }
        }
        else{
          input.classList.remove("valid");
          input.classList.add("invalid");
        } 
      }
      if(inputType == "confirm_password"){
        let message=this.value;
        let password = document.querySelector('#create_password').value;

        if(message.length > 4){
          input.classList.remove("missing");
          if(password === message){


            input.classList.remove("invalid");
            input.classList.add("valid");
            document.querySelector('#create_password').classList.remove("invalid");
            document.querySelector('#create_password').classList.add("valid");  
            input.classList.remove("error");
          }else{

            input.classList.remove("valid");
            input.classList.add("invalid");
            input.classList.add("error"); 
          }

        }
        else{
          console.log("Invelid")
          input.classList.remove("valid");
          input.classList.add("invalid");
          input.classList.remove("error");
        }
      }
    }
  }
  let formSubmit = document.querySelectorAll(".form_box form#create_customer button[type='submit']");
  for (var i = 0; i < formSubmit.length; i++) {
    formSubmit[i].onclick = function(event) {

      let error_free=true;
      let length = $('form#create_customer input').length;
      let formInput = document.querySelectorAll("form#create_customer .txtbox");
      let wholeerror = document.querySelectorAll(".wholeerror");
      for (let i = 0; i < formInput.length; i++) {
        let value = formInput[i].value;
        let valid = formInput[i].classList.contains("valid");

        if (!valid){
          formInput[i].classList.add("missing");
          error_free=false;
        }else{
          formInput[i].classList.remove("missing"); 
        }
      }


      if (!error_free){
        event.preventDefault();
        wholeerror[0].style.display = "";
      }
      else{
        wholeerror[0].style.display = "none";
        setCookie("ClubKarmaPopup", "true", "30");
      }
    }
  }
  
  
  
 
  if($(".userEmail").length > 0){
    let email =$(".thankyoureg_page").attr('data_useremail')
    
    if(email != ''){
      $(".userEmail").html(email);
    }
  }
  $("nav#AccessibleNav li").mouseover(function() {
    getMegaMenu(); 
  })
  OpenClubPoup();
  setTimeout(function(){
    if(window.location.hash == "#contact_form") {
      // smooth scroll to the anchor id
      $('html, body').animate({
        scrollTop: "9999px"
      }, 1000, 'swing');
    }  
  },500);
});

